import { Environments } from '@/config';
import { MUSC_PRODUCTION } from './musc.production';
import { MUSC_STAGING } from './musc.staging';

export const MUSC = import.meta.env.MODE === Environments.PROD ? MUSC_PRODUCTION : MUSC_STAGING;
